import Image1 from "../assets/images/Group 82.webp";
import Image2 from "../assets/images/mock-gcb 1.webp";
import Image3 from "../assets/images/visaya 1.webp";
import Image4 from "../assets/images/mock-itechlabs 2.webp";
import Image5 from "../assets/images/foote-cert.webp";
import Image6 from "../assets/images/mock-threatmetrix.webp";
import Image7 from "../assets/images/tng.webp";
import Image8 from "../assets/images/grab.webp";
import Image9 from "../assets/images/fpx.webp";
import Image10 from "../assets/images/duitnow.webp";
import { Link } from "react-router-dom";
import SocialIcons from "./social-icons"; // Assuming you have a SocialIcons component
import RouteMap from "config/RouteMap";
import { isMobile } from "react-device-detect";
import _CONFIG_ from "config/Constant";
import GA from "components/GA";

export default function Footer() {
  const { GTM_ID } = _CONFIG_;
  return (
    <>
      {isMobile ? (
        <div id="footer-btns">
          <a
            href={_CONFIG_.REGISER_URL}
            className="btn-login"
            rel="noopener nofollow"
          >
            Login
          </a>
          <a href={_CONFIG_.REGISER_URL} rel="noopener nofollow">
            Register
          </a>
        </div>
      ) : null}

      <footer>
        <div className="container">
          <div className="row no-gutter flex-row">
            <div className="foot-cols">
              <p className="h4">About Us</p>
              <div className="foot-col-content">
                <p>
                  Heng Ong Bet Malaysia is the official online casino platform
                  for fun games, slots and rewards. Visit ori-hengongbet.com to
                  register, download the Heng Ong Bet APK and play on Android,
                  iOS, or Hengongbetplay with welcome bonuses!
                </p>
              </div>
            </div>
            <div className="foot-cols">
              <p className="h4">GAMES</p>
              <div className="footer-menu">
                <ul className="foot-col-content flex flex-dir-col g-10">
                  <li>
                    <Link to={RouteMap.slots}>Slots</Link>
                  </li>
                  <li>
                    <Link to={RouteMap.liveCasino}>Live Casino</Link>
                  </li>
                  <li>
                    <Link to={RouteMap.sports}>Sports</Link>
                  </li>
                  <li>
                    <Link to={RouteMap.lottery}>Lottery</Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="foot-cols">
              <p className="h4">CERT & LICENSE</p>
              <div className="footer-menu">
                <ul className="foot-col-content flex flex-dir-col g-10">
                  <li>
                    <a
                      href={`${process.env.PUBLIC_URL}/certs-license/gli--asia-football-stars.pdf`}
                    >
                      GLI Certificate
                    </a>
                  </li>
                  <li>
                    <a
                      href={`${process.env.PUBLIC_URL}/certs-license/egld-426-eg-form-no-9-new-system-game-machine-request.pdf`}
                    >
                      PAGCOR Approval Form
                    </a>
                  </li>
                  <li>
                    <a
                      href={`${process.env.PUBLIC_URL}/certs-license/joint-certification-qnx-3oct24.pdf`}
                    >
                      Joint Certification
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="foot-cols">
              <p className="h4">HELP</p>
              <div className="footer-menu">
                <ul className="foot-col-content flex flex-dir-col g-10">
                  <li>
                    <Link to={RouteMap.download}>Download</Link>
                  </li>
                  <li>
                    <Link to={RouteMap.login}>Login</Link>
                  </li>
                  <li>
                    <Link to={RouteMap.register}>Register</Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="foot-cols">
              <p className="h4">FOLLOW US</p>
              <div className="flex foot-col-content g-10 justify-center">
                <a
                  href="https://www.facebook.com/people/HengongbetOfficial/61578129191374/"
                  target="_blank"
                  aria-label="Facebook"
                >
                  <SocialIcons.FB />
                </a>
                <a href="https://x.com/KkJonus58599" target="_blank" aria-label="Twitter">
                  <SocialIcons.TW />
                </a>
                <a
                  href="https://www.instagram.com/hengong_bet/"
                  target="_blank"
                  aria-label="Instagram"
                >
                  <SocialIcons.IG />
                </a>
                <a href="https://t.me/hengongbet11" target="_blank" aria-label="Telegram">
                  <SocialIcons.TG />
                </a>
                <a
                  href="https://www.youtube.com/@Hengongbet_official"
                  target="_blank"
                  aria-label="YouTube"
                >
                  <SocialIcons.YT />
                </a>
              </div>
            </div>
          </div>
          <div class="hr"></div>
          <div className="row no-gutter flex-row mt-40">
            <div className="foot-cols">
              <p className="h4">GAMING LICENSE</p>
              <div className="flex foot-col-content g-10 justify-center">
                <img src={Image1} loading="lazy" alt="Hengong bet Paggor" />
                <img src={Image2} loading="lazy" alt="Hengong bet GCB" />
              </div>
            </div>
            <div className="foot-cols">
              <p className="h4">CERTIFICATIONS</p>
              <div className="flex foot-col-content g-10 justify-center">
                <img src={Image3} loading="lazy" alt="Hengong bet Ori" />
                <img src={Image4} loading="lazy" alt="Hengong bet Itech labs" />
                <img src={Image5} loading="lazy" alt="Hengong bet Universe" />
              </div>
            </div>
            <div className="foot-cols">
              <p className="h4">SECURITY</p>
              <div className="flex foot-col-content g-10 justify-center">
                <img
                  src={Image6}
                  loading="lazy"
                  alt="Hengong bet Threat Metrix"
                />
              </div>
            </div>
            <div className="foot-cols">
              <p className="h4">PAYMENT METHOD</p>
              <div className="flex foot-col-content g-10 justify-center">
                <img src={Image7} loading="lazy" alt="Hengong bet Touch n Go" />
                <img src={Image8} loading="lazy" alt="Hengong bet Grab Play" />
                <img src={Image9} loading="lazy" alt="Hengong bet FPX" />
                <img src={Image10} loading="lazy" alt="Hengong bet Duit now" />
              </div>
            </div>
          </div>
          <div className="row no-gutter justify-center mt-30">
            <p className="copy-right">
              Copyright © 2025 ori-hengongbet.com. All rights reserved.
            </p>
          </div>
        </div>
      </footer>
      <GA trackingId={GTM_ID} />
    </>
  );
}
